import React from 'react';

import WidgetInput from './WidgetInput';

import PropsSelect from './interfaces/PropsSelectInterface';

export default class WidgetSelect extends WidgetInput<PropsSelect> {
    constructor(props: PropsSelect) {
        super(props);
        if (
            this.options(false).length === 1 &&
            !this.props.multiple &&
            this.props.required === true
        ) {
            const value = this.options(false)[0].key.toString();
            this.props.handleChange(this.props.name, value);
        }
    }
    render() {
        return React.createElement(
            'select',
            {
                id: this.props.id,
                name: this.props.name,
                required: this.props.required,
                multiple: this.props.multiple,
                onChange: (event: React.ChangeEvent<HTMLSelectElement>) =>
                    this.props.handleChange(this.props.name, event.target.value),
                className: this.props.className,
            },
            this.options()
        );
    }

    options(includeEmpty = true) {
        let options = this.props.options.map(opt =>
            React.createElement(
                'option',
                {
                    key: opt.value,
                    value: opt.value,
                    selected: this.getRenderValue() == opt.value,
                    disabled: opt.disabled,
                },
                [opt.label]
            )
        );
        if (includeEmpty) {
            options.unshift(
                React.createElement(
                    'option',
                    {
                        key: '',
                        value: '',
                        selected: this.getRenderValue() === '',
                        disabled: false,
                    },
                    [this.props.placeholder]
                )
            );
        }
        return options;
    }
}
